<template>
    <div class="animated fadeIn">
        <b-row col="12">
          <b-col>
            <b-btn class="pull-right" variant="primary" to="settings" :append="true">
              <i class="cui-cog"></i>
            </b-btn>
          </b-col>
        </b-row>
        <br />
        <b-row>
            <b-col cols="12" xl="12">
                <transition name="slide">
                    <b-card>
                        <template v-if="items.length < 1">
                          {{ $t('noEvents') }}
                        </template>
                        <b-list-group>
                            <Event :event="item" v-for="item in items" v-bind:key="item.uuid"/>
                            <scroll-loader :loader-method="getEvents" :loader-disable="disableLoader"></scroll-loader>
                        </b-list-group>
                    </b-card>
                </transition>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Event from './Event'

export default {
    name: "Events",
    components: {
        Event,
    },
    data: function() {
        return {
            items: [],
            fields: [
                {
                    key: "action",
                    label: this.$t('action'),
                    sortable: true
                }
            ],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            disableLoader: false
        }
    },
    methods: {
        rowClicked(item) {
            if (this.$can("inspect base_events")) {
                const link = "/admin/scout/events/" + item.uuid
                this.$router.push({path: link})
            }
        },

        getEvents() {
            this.$http.get("/v1/system/events", {
                params: {
                    limit: 10,
                    offset: this.currentPage++
                }
            }).then((resp) => {
                if (resp.status == 200) {
                    if (resp.data !== null) {
                        this.items = this.items.concat(resp.data)

                        this.$store.commit("SET_EVENTS", resp.data)

                        if (resp.data.length < 10) {
                            this.disableLoader = true
                        }
                    }
                }
            }).catch((error) => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }
            })
        }
    },

    mounted() {
        this.getEvents()

        this.$store.commit("SET_USER_CHECK_EVENTS")
    }
}
</script>
